import * as yup from 'yup';
import { AreaOptions } from './Data.conf';

export const UpdateConf = {
  schema: yup.object({
    code: yup.string().nullable().required('Code is required'),
    marina: yup.string().nullable().required('Marina is required'),
    location: yup.string().nullable().required('Location is required'),
    area: yup.object().nullable(),
  }),
  defaultValues: {
    code: null,
    marina: null,
    location: null,
    area: null,
  },
  fields: [
    {
      id: 'location',
      name: 'location',
      type: 'text',
      label: 'Location',
      required: true,
      xs: 12,
      md: 6,
    },
    {
      id: 'code',
      name: 'code',
      type: 'text',
      label: 'Code',
      required: true,
      xs: 12,
      md: 6,
    },
    {
      id: 'marina',
      name: 'marina',
      type: 'text',
      label: 'Marina',
      required: true,
      xs: 12,
      md: 6,
    },
    {
      id: 'area',
      name: 'area',
      type: 'autocomplete',
      label: 'Area',
      options: AreaOptions,
      xs: 12,
      sm: 6,
    },
  ],
};
